import { useContext } from "react";
import { AppConfigCtx } from "@/providers/AppConfig";
import type { tAppConfig } from "_t/appConfig";

export const useAppConfig = (): tAppConfig => {
  return useContext(AppConfigCtx);
};
